export const REMOVE_CONFLICT = 'REMOVE_CONFLICT';

export const removeConflict = (firstContext, secondContext, typeConflict) => ({
  type: REMOVE_CONFLICT,
  firstContext,
  secondContext,
  typeConflict,
});
